<template>
  <div class="particle" :style="particleStyle"></div>
</template>

<script>
export default {
  props: {
    x: Number,
    y: Number,
    gradient: Boolean
  },
  computed: {
    particleStyle() {
      return {
        left: `${this.x}px`,
        top: `${this.y}px`,
        width: `${this.size}px`,
        height: `${this.size}px`,
        backgroundColor: this.gradient ? this.getRandomGradientColor() : this.getRandomColor(),
        animation: 'fly-out 2s ease forwards, scale-up 2s ease forwards'
      };
    },
    size() {
      return this.gradient ? 20 : 10; // Increase size for gradient particles
    }
  },
  methods: {
    getRandomColor() {
      const colors = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff'];
      return colors[Math.floor(Math.random() * colors.length)];
    },
    getRandomGradientColor() {
      const angle = Math.random() * 360;
      const color1 = this.getRandomColor();
      const color2 = this.getRandomColor();
      return `conic-gradient(from ${angle}deg, ${color1}, ${color2})`;
    }
  }
};
</script>

<style scoped>
.particle {
  position: absolute;
  border-radius: 50%;
}

@keyframes fly-out {
  0% {
    transform: translateZ(0);
    opacity: 1;
  }
  100% {
    transform: translateZ(-2000px);
    opacity: 0;
  }
}

@keyframes scale-up {
  0% {
    transform: scale(0.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>
